import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import api from '../utils/api';

// ── Iconos SVG reales ────────────────────────────────────────────────
const IconPhone = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
    <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"/>
  </svg>
);
const IconWhatsApp = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);
const IconEmail = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
    <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
  </svg>
);
const IconWeb = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
  </svg>
);
const IconLinkedIn = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);
const IconInstagram = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
  </svg>
);
const IconTikTok = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.32 6.32 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.19 8.19 0 004.79 1.54V6.78a4.85 4.85 0 01-1.02-.09z"/>
  </svg>
);
const IconYouTube = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
  </svg>
);
const IconContact = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M20 0H4C2.9 0 2 .9 2 2v20l4-4h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-8 12c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm6 4H6v-.57c0-1.01.57-1.9 1.44-2.28C8.64 12.5 10.26 12 12 12s3.36.5 4.56 1.15c.87.38 1.44 1.27 1.44 2.28V16z"/>
  </svg>
);

// ── Helpers ──────────────────────────────────────────────────────────
const fixUrl = (url) => {
  if (!url) return '';
  return url.startsWith('http') ? url : 'https://' + url;
};

const fontMap = {
  modern:  "'Sora', sans-serif",
  elegant: "'Playfair Display', serif",
  tech:    "'Share Tech Mono', monospace",
  rounded: "'Nunito', sans-serif",
};

const fontLinks = {
  modern:  "https://fonts.googleapis.com/css2?family=Sora:wght@300;400;600;700&display=swap",
  elegant: "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&display=swap",
  tech:    "https://fonts.googleapis.com/css2?family=Share+Tech+Mono&display=swap",
  rounded: "https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;600;700&display=swap",
};

// ── Texturas / fondos animados ───────────────────────────────────────
const ParticlesBackground = ({ acento }) => {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
    const particles = Array.from({ length: 60 }, () => ({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height,
      r: Math.random() * 2 + 0.5,
      dx: (Math.random() - 0.5) * 0.4,
      dy: (Math.random() - 0.5) * 0.4,
      o: Math.random() * 0.5 + 0.1,
    }));
    let animId;
    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(p => {
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = acento + Math.floor(p.o * 255).toString(16).padStart(2, '0');
        ctx.fill();
        p.x += p.dx; p.y += p.dy;
        if (p.x < 0 || p.x > canvas.width) p.dx *= -1;
        if (p.y < 0 || p.y > canvas.height) p.dy *= -1;
      });
      animId = requestAnimationFrame(draw);
    };
    draw();
    return () => cancelAnimationFrame(animId);
  }, [acento]);
  return <canvas ref={canvasRef} className="absolute inset-0 w-full h-full" style={{ opacity: 0.6 }} />;
};

const WavesBackground = ({ acento }) => (
  <div className="absolute inset-0 overflow-hidden">
    {[0, 1, 2].map(i => (
      <div key={i} className="absolute inset-0" style={{
        background: `radial-gradient(ellipse at ${30 + i * 20}% ${40 + i * 15}%, ${acento}20 0%, transparent 60%)`,
        animation: `pulse ${3 + i}s ease-in-out infinite alternate`,
        animationDelay: `${i * 0.8}s`,
      }} />
    ))}
  </div>
);

const GeometricBackground = ({ acento }) => (
  <div className="absolute inset-0 overflow-hidden opacity-20">
    <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <pattern id="geo" x="0" y="0" width="60" height="60" patternUnits="userSpaceOnUse">
          <polygon points="30,0 60,30 30,60 0,30" fill="none" stroke={acento} strokeWidth="0.5"/>
          <circle cx="30" cy="30" r="4" fill="none" stroke={acento} strokeWidth="0.5"/>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#geo)"/>
    </svg>
  </div>
);

// ── Componente principal ─────────────────────────────────────────────
const PerfilPublico = () => {
  const { codigo } = useParams();
  const [perfil, setPerfil] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/nfc/${codigo}`)
      .then(({ data }) => setPerfil(data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [codigo]);

  useEffect(() => {
    if (!perfil) return;
    const fuente = perfil.fuente || 'modern';
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = fontLinks[fuente];
    document.head.appendChild(link);
    return () => document.head.removeChild(link);
  }, [perfil]);

  const handleVCard = () => {
    if (!perfil) return;
    const vcard = [
      'BEGIN:VCARD', 'VERSION:3.0',
      `FN:${perfil.nombre} ${perfil.apellido}`,
      `N:${perfil.apellido};${perfil.nombre};;;`,
      perfil.cargo    ? `TITLE:${perfil.cargo}`             : '',
      perfil.empresa  ? `ORG:${perfil.empresa}`             : '',
      perfil.telefono ? `TEL;TYPE=VOICE:${perfil.telefono}` : '',
      perfil.whatsapp ? `TEL;TYPE=CELL:${perfil.whatsapp}`  : '',
      perfil.email    ? `EMAIL:${perfil.email}`             : '',
      perfil.website  ? `URL:${fixUrl(perfil.website)}`     : '',
      'END:VCARD'
    ].filter(Boolean).join('\n');
    const blob = new Blob([vcard], { type: 'text/vcard' });
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href = url; a.download = `${perfil.nombre}_${perfil.apellido}.vcf`;
    a.click(); URL.revokeObjectURL(url);
  };

  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-gray-950">
      <div className="w-8 h-8 border-2 border-cyan-400 border-t-transparent rounded-full animate-spin" />
    </div>
  );

  if (notFound) return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-950 gap-4 px-4">
      <div className="text-6xl">💳</div>
      <h1 className="text-xl font-semibold text-white">Perfil no encontrado</h1>
      <p className="text-gray-400 text-sm text-center">Esta tarjeta no está activa o no existe.</p>
    </div>
  );

  const fondo  = perfil.color_fondo  || '#0a0f1e';
  const acento = perfil.color_acento || '#00d4ff';
  const fuente = perfil.fuente       || 'modern';
  const textura= perfil.textura      || 'particles';

  const youtubeId = perfil.youtube
    ? perfil.youtube.match(/(?:v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/)?.[1]
    : null;

  const redes = [
    { key: 'linkedin',  url: perfil.linkedin,  icon: <IconLinkedIn />,  label: 'LinkedIn',  bg: '#0A66C2' },
    { key: 'instagram', url: perfil.instagram, icon: <IconInstagram />, label: 'Instagram', bg: 'linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)' },
    { key: 'tiktok',    url: perfil.tiktok,    icon: <IconTikTok />,    label: 'TikTok',    bg: '#000000' },
    { key: 'youtube',   url: perfil.youtube,   icon: <IconYouTube />,   label: 'YouTube',   bg: '#FF0000' },
  ].filter(r => r.url);

  const acentoRgb = acento.replace('#','').match(/.{2}/g)?.map(h => parseInt(h,16)).join(',') || '0,212,255';

  return (
    <div className="min-h-screen flex flex-col items-center" style={{ backgroundColor: fondo, fontFamily: fontMap[fuente] }}>

      <style>{`
        @keyframes pulse { 0%{opacity:.4} 100%{opacity:.8} }
        @keyframes glow  { 0%,100%{box-shadow:0 0 20px 4px rgba(${acentoRgb},.4)} 50%{box-shadow:0 0 40px 8px rgba(${acentoRgb},.7)} }
        @keyframes fadeUp{ from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
        .fade-up { animation: fadeUp .6s ease forwards; }
        .fade-up-1 { animation-delay: .1s; opacity:0; }
        .fade-up-2 { animation-delay: .2s; opacity:0; }
        .fade-up-3 { animation-delay: .3s; opacity:0; }
        .fade-up-4 { animation-delay: .4s; opacity:0; }
        .fade-up-5 { animation-delay: .5s; opacity:0; }
        .glow-ring  { animation: glow 2.5s ease-in-out infinite; }
        .btn-acento { background: linear-gradient(135deg, ${acento}, ${acento}cc); color: #000; }
        .btn-acento:hover { filter: brightness(1.15); }
        .btn-outline { border: 1px solid ${acento}66; color: ${acento}; }
        .btn-outline:hover { background: ${acento}15; }
        .red-dot { background: ${acento}; }
      `}</style>

      {/* Fondo animado */}
      <div className="fixed inset-0 pointer-events-none">
        {textura === 'particles'  && <ParticlesBackground acento={acento} />}
        {textura === 'waves'      && <WavesBackground acento={acento} />}
        {textura === 'geometric'  && <GeometricBackground acento={acento} />}
        <div className="absolute inset-0" style={{ background: `radial-gradient(ellipse at 50% 0%, ${acento}18 0%, transparent 65%)` }} />
      </div>

      {/* Contenido */}
      <div className="relative z-10 w-full max-w-sm px-4 py-10 flex flex-col items-center">

        {/* Foto */}
        <div className="fade-up fade-up-1 mb-5">
          <div className="w-28 h-28 rounded-full overflow-hidden glow-ring" style={{ border: `3px solid ${acento}` }}>
            {perfil.foto_url ? (
              <img src={perfil.foto_url} alt="Foto" className="w-full h-full object-cover" />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-4xl font-bold text-white"
                   style={{ background: `linear-gradient(135deg, ${acento}44, ${fondo})` }}>
                {perfil.nombre?.charAt(0) || '?'}
              </div>
            )}
          </div>
        </div>

        {/* Nombre y cargo */}
        <div className="fade-up fade-up-2 text-center mb-6">
          <h1 className="text-2xl font-bold text-white mb-1">
            {perfil.nombre} {perfil.apellido}
          </h1>
          {perfil.cargo && (
            <p className="text-sm font-medium mb-0.5" style={{ color: acento }}>{perfil.cargo}</p>
          )}
          {perfil.empresa && (
            <p className="text-xs text-gray-400">{perfil.empresa}</p>
          )}
        </div>

        {/* Botones de contacto rápido */}
        <div className="fade-up fade-up-3 w-full grid grid-cols-3 gap-3 mb-6">
          {perfil.telefono && (
            <a href={`tel:${perfil.telefono}`}
               className="flex flex-col items-center gap-2 py-4 rounded-2xl transition-all btn-outline">
              <span style={{ color: acento }}><IconPhone /></span>
              <span className="text-xs text-gray-300">Llamar</span>
            </a>
          )}
          {perfil.whatsapp && (
            <a href={`https://wa.me/${perfil.whatsapp.replace(/\D/g,'')}`}
               target="_blank" rel="noreferrer"
               className="flex flex-col items-center gap-2 py-4 rounded-2xl transition-all btn-outline">
              <span style={{ color: '#25D366' }}><IconWhatsApp /></span>
              <span className="text-xs text-gray-300">WhatsApp</span>
            </a>
          )}
          {perfil.email && (
            <a href={`mailto:${perfil.email}`}
               className="flex flex-col items-center gap-2 py-4 rounded-2xl transition-all btn-outline">
              <span style={{ color: acento }}><IconEmail /></span>
              <span className="text-xs text-gray-300">E-mail</span>
            </a>
          )}
        </div>

        {/* Redes sociales */}
        {redes.length > 0 && (
          <div className="fade-up fade-up-3 w-full mb-6">
            <div className="flex justify-center gap-3 flex-wrap">
              {redes.map(r => (
                <a key={r.key} href={fixUrl(r.url)} target="_blank" rel="noreferrer"
                   className="w-11 h-11 rounded-xl flex items-center justify-center text-white transition-all hover:scale-110 hover:opacity-90"
                   style={{ background: r.bg }} title={r.label}>
                  {r.icon}
                </a>
              ))}
            </div>
          </div>
        )}

        {/* Bio */}
        {perfil.bio && (
          <div className="fade-up fade-up-4 w-full mb-5 rounded-2xl p-4"
               style={{ background: `${acento}0d`, border: `1px solid ${acento}22` }}>
            <p className="text-xs font-semibold uppercase tracking-widest mb-2" style={{ color: acento }}>Acerca de mí</p>
            <p className="text-sm text-gray-300 leading-relaxed">{perfil.bio}</p>
          </div>
        )}

        {/* Video YouTube */}
        {youtubeId && (
          <div className="fade-up fade-up-4 w-full mb-5 rounded-2xl overflow-hidden"
               style={{ border: `1px solid ${acento}22` }}>
            <iframe className="w-full" height="195"
              src={`https://www.youtube.com/embed/${youtubeId}`}
              title="Video" frameBorder="0" allowFullScreen />
          </div>
        )}

        {/* Sitio web */}
        {perfil.website && (
          <div className="fade-up fade-up-4 w-full mb-3">
            <a href={fixUrl(perfil.website)} target="_blank" rel="noreferrer"
               className="flex items-center justify-center gap-2 w-full py-3.5 rounded-2xl text-sm font-medium transition-all btn-outline">
              <IconWeb /> Visitar sitio web
            </a>
          </div>
        )}

        {/* Guardar contacto — CTA principal */}
        <div className="fade-up fade-up-5 w-full mb-8">
          <button onClick={handleVCard}
            className="flex items-center justify-center gap-2 w-full py-4 rounded-2xl text-sm font-bold transition-all btn-acento hover:scale-[1.02] active:scale-[0.98]">
            <IconContact /> Guardar contacto
          </button>
        </div>

        {/* Footer */}
        <div className="fade-up fade-up-5 flex items-center gap-2">
          <div className="w-1.5 h-1.5 rounded-full red-dot animate-pulse" />
          <p className="text-xs text-gray-500">Powered by <span className="font-semibold text-gray-400">Time Telco</span></p>
        </div>

      </div>
    </div>
  );
};

export default PerfilPublico;
